export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/NewlyAddedEn.d78bfaa0.svg","height":48,"width":70,"blurWidth":0,"blurHeight":0};